import { Injectable, Inject } from '@nestjs/common';
import {getmandalDTO, searchDto, VillageDTO} from './dto/village.dto';
import { Repository, Raw, getConnection, Like } from 'typeorm';
import { VillageEntity } from './village.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { VillageResponseModel } from './dto/village-response.model';
import { AllVillageResponseModel, searchResponseModel } from './dto/all-village-response-model';
import { VillageStatusWiseResponseModel } from './dto/village-status-response.model';

@Injectable()
export class VillageService {
  constructor(
    @InjectRepository(VillageEntity)
    private villageRepository: Repository<VillageEntity>,
  ) {}  

  async createVillage(queryParams, villageDto: VillageDTO, isUpdate: boolean,request:Request): Promise<VillageResponseModel> {
    const response = new VillageResponseModel();
    try {
      if (!isUpdate) {
        const VillageEntity = await this.getVillageDetailsWithoutRealtions(villageDto.villageName);
        if (VillageEntity) {
          throw new ErrorResponse(11104, 'Village already exists');         
        } else {
          if(queryParams.apiVersion == 1) {
            const savedVillage = await this.villageRepository.save(villageDto);
            if (savedVillage) {
              response.status = true;
              response.data = savedVillage;
              response.statusCode = 50000;
              response.internalMessage = 'Village Created Successfully';
              response.intlCode = 11100;
            } else {
              throw new ErrorResponse(11106,'village Not Created');
            }
          } else {
            const savedVillage = await this.villageRepository.save(
              villageDto
            );
            if (savedVillage) {
              response.status = true;
              response.data = savedVillage;
              response.statusCode = 50000;
              response.internalMessage = 'Village Created Successfully';
              response.intlCode = 11100;
            } else {
              throw new ErrorResponse(11106,'Village Not Created');
            }
          }
        } 
      } else{
        if(queryParams.apiVersion == 1) {
          const updatedVillage = await this.villageRepository.update(villageDto.Id,villageDto);
          const updatedData = await this.villageRepository.findOne({
            where:{villageId:villageDto.Id}
          });
          if (updatedVillage) {
            response.status = true;
            response.data = updatedData;
            response.statusCode = 50000;
            response.internalMessage = 'village Updated Successfully';
            response.intlCode = 11100;
          } else {
            throw new ErrorResponse(99998,'Vilage Not Updated');
          }
        } else {
          const updatedVillage = await this.villageRepository.update(villageDto.Id,villageDto);
          const updatedData = await this.villageRepository.findOne({
            where:{villageId:villageDto.Id}
          });
          if (updatedVillage) {
            response.status = true;
            response.data = updatedData;
            response.statusCode = 50000;
            response.internalMessage = 'Village Updated Successfully';
            response.intlCode = 11100;
          } else {
            throw new ErrorResponse(11106,'Village Not Updated');
          }
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }
  async getVillageDetailsWithoutRealtions (villageName: string): Promise<VillageEntity> {
    const villageResponse = await this. villageRepository.findOne({
        where : {villageName: Raw(alias => `UPPER(village_name) = '${villageName.toLocaleUpperCase()}'`), status: true},
    });
    if (villageResponse) {
        return villageResponse;
    }else{
        return null;
    }
  }

    async getAllVillages(queryParams,request:Request): Promise<AllVillageResponseModel> {
      const response = new AllVillageResponseModel();
      try{
          if (queryParams.apiVersion == 1) {
              const villageData = await this.villageRepository.find({
                  order: {createdAt: 'DESC'}
              });
              if (villageData) {
                  response.status = true;
                  response.data = villageData;
                  response.statusCode = 50000;
                  response.internalMessage = 'Village retrived successfully';
                  response.intlCode = 11108;
              } else {
                  throw new ErrorResponse(99998, 'Village Records Not Found');
              }
          } else {
              const villageData = await this.villageRepository.find({
                  order:{createdAt: 'DESC'}
              });
          
                if (villageData) {
                  response.status = true;
                  response.data = villageData;
                  response.statusCode = 50000;
                  response.internalMessage = 'Village Retrieved successfully';
                  response.intlCode = 11108;
              } else{
                  throw new ErrorResponse(99998, 'Village Records Not Found');
              }
          } return response;
         } catch (err) {
             throw err;
         }
     }


    async getVillageByVillageName(queryParams, villageName: string, request:Request): Promise<VillageResponseModel>{
        const response = new VillageResponseModel();
        try{
            if (queryParams.apiVersion == 1) {
                const villageResponse = await this. villageRepository.findOne({
                    where:{villageName:Raw (alias => `UPPER (village_name)='${villageName.toLocaleUpperCase()}'`)
                   }
                });
                if (villageResponse) {
                    response.status = true;
                    response.data = villageResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'village Record Found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse (99998, 'Village Record Not Found');
                }
            }else{
                const villageResponse = await this.villageRepository.findOne({
                    where:{villageName: Raw (alias =>`UPPER(village_name) = '${villageName.toLocaleUpperCase()}'`)
                   }
                });
                if (villageResponse) {
                    response.status = true;
                    response.data = villageResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'Village record Found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse (99998, 'Village Record Not Found');
                }
            }
            return response ;
           } catch (error) {
               throw error;
            }
        }

        
       async getVillageByVillageId (queryParams , villageId: number,request:Request): Promise<VillageResponseModel>{
        const response = new VillageResponseModel();
        try{
            if (queryParams.apiVersion == 1){
          const villageResponse = await this.villageRepository.findOne({
            where:{Id: Raw(alias =>` village_id= '${villageId}'`)
        }
       });
       if (villageResponse) {
           response.status = true;
           response.data = villageResponse;
           response.statusCode = 50000;
           response.internalMessage = 'village Record Found';
           response.intlCode = 11107;
       } else {
           throw new ErrorResponse(99998, 'village Record Not Found');
       }
       } else{
         const villageResponse = await this.villageRepository.findOne({
             where:{Id: Raw(alias =>`village_id= '${villageId}'`)}
         });
         if (villageResponse) {
             response.status = true;
             response.data = villageResponse;
             response.statusCode = 50000;
             response.internalMessage = 'Village Record Found';
             response.intlCode = 11107;
         } else {
             throw new ErrorResponse(99998, 'village Record Not Found');
         }
       }
       return response;
      }catch(error){
          throw error;
      }
   }  

   async getAllActiveVillages(queryParams,request:Request): Promise<AllVillageResponseModel> {
       const response = new AllVillageResponseModel();
       try{
           if (queryParams.apiVersion == 1) {
               const villageData = await this.villageRepository.find({
                   where:{ status: true},
                   order: {createdAt: 'DESC'}
               });
               if (villageData) {
                   response.status = true;
                   response.data = villageData;
                   response.statusCode = 50000;
                   response.internalMessage = 'Village retrived successfully';
                   response.intlCode = 11108;
               } else {
                   throw new ErrorResponse(99998, 'Village Records Not Found');
               }
           } else {
               const villageData = await this.villageRepository.find({
                   where :{status: true},
                   order:{createdAt: 'DESC'}
               });
           
                 if (villageData) {
                   response.status = true;
                   response.data = villageData;
                   response.statusCode = 50000;
                   response.internalMessage = 'Village Retrieved successfully';
                   response.intlCode = 11108;
               } else{
                   throw new ErrorResponse(99998, 'Village Records Not Found');
               }
           } return response;
          } catch (err) {
              throw err;
          }
      }

     async getActiveVillageCount(queryParams,request:Request): Promise<VillageStatusWiseResponseModel>{
         const response = new VillageStatusWiseResponseModel();
         try{
             if (queryParams.apiVersion == 1) {
                 const villageStatusWiseCount = await getConnection()
                 .createQueryBuilder()
                 .select("Sum(IF(status = true, 1,0 )) as activeCount,Sum(IF(status = false ,1,0)) as inActiveCount, count(*) as cnt")
                 .from(VillageEntity, "mandal")
                 .orderBy('status','ASC')
                 .getRawOne();
                 if (villageStatusWiseCount) {
                     response.status = true;
                     response.active = villageStatusWiseCount.activeCount;
                     response.inActive = villageStatusWiseCount.inActiveCount;
                     response.total = villageStatusWiseCount.cnt;
                     response.statusCode = 50000;
                     response.internalMessage = 'Village Retrived Successfully';
                     response.intlCode = 11108;
                 }  else{
                     throw new ErrorResponse(99998, 'village not found');
                 }                   
              } else{
                  const villageStatusWiseCount= await getConnection()
                  .createQueryBuilder()
                  .select("Sum(IF(status = true,1,0)) as activeCount,Sum(IF(status =false ,1,0)) as inActiveCount, count(*) as cnt")
                  .from(VillageEntity,"mandal")
                  .orderBy('status','ASC')
                  .getRawOne();
                  if (villageStatusWiseCount) {
                      response.status = true;
                      response.active = villageStatusWiseCount.activeCount;
                      response.inActive = villageStatusWiseCount.inActiveCount;
                      response.total = villageStatusWiseCount.cnt;
                      response.statusCode = 50000;
                      response.internalMessage = 'village retrieved successfully';
                      response.intlCode = 11108;
                    } else {
                      throw new ErrorResponse(99998, 'village  Not Found');
                    }
                  }
                  return response;
                } catch (err) {
                  throw err;
                }
              }
  async updateVillageStatus(queryParams,villageStatusDto, request):Promise<VillageResponseModel>{
    const response = new VillageResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        await this.villageRepository.update(villageStatusDto.Id,villageStatusDto);
        const states = await this.villageRepository.findOne({
          where: { Id:villageStatusDto.Id },
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Village status updated successfully';
          response.intlCode = 11108;
        } else {
        throw new ErrorResponse(99998, 'Village status update failed');
        }
      } else {
        await this.villageRepository.update(villageStatusDto.Id,villageStatusDto);
        const states = await this.villageRepository.findOne({
          where: { Id:villageStatusDto.Id },
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Village status updated successfully';
          response.intlCode = 11108;
        } else {
        throw new ErrorResponse(99998, 'Village status update failed');
        }
      }      
      return response;
    } catch (error) {
      throw error;
    }
  }   
  async getVillagesByMandalId(queryParams, getmandalDTO:getmandalDTO, request: Request): Promise<searchResponseModel> {
    const response = new searchResponseModel();
    try {
        if(queryParams.apiVersion == 1) {
            const activeTypes = await this.villageRepository.find({               
                where: {mandalId:getmandalDTO.mandalId,status: true},
                //relations:['mandal'],
                order: { createdAt: 'DESC' }
            });
            if(activeTypes) {
                response.status = true;
                response.data = activeTypes;
                response.statusCode = 50000;
                response.internalMessage = 'data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } else {
          const activeTypes = await this.villageRepository.find({
               
            where: {mandalId:getmandalDTO.mandalId,status: true},
            //relations:['mandal'],
            order: { createdAt: 'DESC' }
        });
        if(activeTypes) {
            response.status = true;
            response.data = activeTypes;
            response.statusCode = 50000;
            response.internalMessage = 'data retrieved successfully';
            response.intlCode = 11108;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
        }
        return response;
    } catch (error) {
        throw error;
    }
  }
  
  async getSearchPlace(queryParams,searchDto:searchDto,request:Request):Promise<searchResponseModel> {
    const response = new searchResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        const data = await this.villageRepository.find({               
          where: {villageName: Like(`%${searchDto.place}%`),status: true},
          order: { createdAt: 'DESC' }
        });
        if(data) {
          response.status = true;
          response.data = data;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const data = await this.villageRepository.find({               
          where: {villageName: Like(`%${searchDto.place}`),status: true},
          order: { createdAt: 'DESC' }
        });
        if(data) {
          response.status = true;
          response.data = data;
          response.statusCode = 50000;
          response.internalMessage = 'data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch(error) {
      throw error;
    }  
  }

}






















































































